import { Button, Icon, Text } from "@ttc3k/trekker";
import { Flask } from "iconoir-react";
import { useNavigate } from "react-router";
import { Collapsible } from "shared/components/molecules";
import { Box, Flex } from "styled-system/jsx";
import { useWorkbenchSession } from "shared/contextProviders/workbenchSession";

/** Shown while a Workbench test session is active, like the impersonation banner. */
export const WorkbenchSessionBanner = () => {
  const { session, isTesting, stopWorkbenchSession, setChatOpen, hasUnread } = useWorkbenchSession();
  const navigate = useNavigate();

  return (
    <Collapsible open={isTesting}>
      <Flex
        w="full"
        h="44px"
        bg="linear-gradient(90deg, #B45309 0%, #D97706 100%)"
        justifyContent="space-between"
        alignItems="center"
        px="300"
        gap="200"
      >
        <Flex gap="150" alignItems="center" color="white" minW="0">
          <Icon Element={Flask} size="sm" css={{ opacity: 0.8 }} />
          <Text visual="bodyMedium" color="white" whiteSpace="nowrap">
            Testing {session?.featureName}
          </Text>
          {session?.organizationName && (
            <Text visual="bodyRegular" color="white" opacity={0.85} truncate hideBelow="md">
              as {session.organizationName}
            </Text>
          )}
        </Flex>
        <Flex gap="200" alignItems="center" flexShrink={0}>
          <Button
            visual="unstyled"
            color="white"
            _hover={{ color: "white/75" }}
            position="relative"
            onClick={() => setChatOpen(true)}
          >
            <Text visual="smallMedium" color="inherit">
              Ask Whereabot
            </Text>
            {hasUnread && (
              <Box
                position="absolute"
                top="-2px"
                right="-10px"
                w="8px"
                h="8px"
                borderRadius="full"
                bg="white"
                title="New reply"
              />
            )}
          </Button>
          <Button
            visual="unstyled"
            color="white"
            _hover={{ color: "white/75" }}
            onClick={() => session && navigate(session.returnTo)}
          >
            <Text visual="smallMedium" color="inherit">
              Back to Workbench
            </Text>
          </Button>
          <Button
            visual="unstyled"
            color="white"
            _hover={{ color: "white/75" }}
            onClick={() => {
              const returnTo = session?.returnTo;
              stopWorkbenchSession();
              if (returnTo) navigate(returnTo);
            }}
          >
            <Text visual="smallMedium" color="inherit">
              End session
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Collapsible>
  );
};
